import Swiper from 'swiper';
import { gtmBubbleIng } from './Seo';
import * as Utils from '../utils/utils';

export default class SwiperJS {
  constructor() {
    [].slice.call(
      document.querySelectorAll('.js-swiper'),
    ).forEach((node) => this.render(node));

    [].slice.call(
      document.querySelectorAll('.js-vc-slideshow-container'),
    ).forEach((node) => this.renderBlock(node));
  }

  goBackToList(listIng, popinHead, swiper, btnClose, btnBack) {
    setTimeout(() => {
      listIng.classList.add('active');
      popinHead.classList.add('active');
    }, 500);
    swiper.classList.remove('active');
    Utils.removeClass(btnBack, 'active');
    Utils.removeClass(btnClose, 'hidden');
  }

  render(node) {
    const ingredients = [...node.closest('.popin-content').querySelectorAll('.ingredient-container .list-ingredient a')];
    const listIngredients = node.closest('.popin-content').querySelector('.ingredient-container');
    const popinHeader = node.closest('.popin.ingredient').querySelector('.popin-header');
    const backToList = node.closest('.popin.ingredient').querySelector('.breadcrumb-item:nth-child(3n)');
    const ingBreadcrumb = node.closest('.popin.ingredient').querySelector('.breadcrumb-item:last-child');
    const swiperContainer = node.closest('.swiper-ingredient');
    const btnClose = node.closest('.popin.ingredient').querySelector('.js-btn-close');
    const btnBack = node.closest('.popin.ingredient').querySelector('.js-btn-back');

    const myswipe = new Swiper(node, {
      loop: false,
      spaceBetween: 100,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.next-slide',
        prevEl: '.prev-slide',
      },
    });

    node.style.height = `calc(${myswipe.slides[myswipe.realIndex].clientHeight}px + 95px)`; // slide's height + padding

    myswipe.on('slideChangeTransitionEnd', () => {
      document.querySelector('.popin.open').scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      ingBreadcrumb.innerHTML = myswipe.slides[myswipe.realIndex].querySelector('.ingredient-content-title').innerHTML;
    });

    myswipe.on('transitionStart', () => {
      node.style.height = `calc(${myswipe.slides[myswipe.realIndex].clientHeight}px + 95px)`; // slide's height + padding
    });

    ingredients.forEach((ing) => {
      const attr = ing.getAttribute('data-index');

      ing.addEventListener('click', (e) => {
        e.preventDefault();

        gtmBubbleIng(ing.dataset.name);

        Utils.addClass(btnClose, 'hidden');
        Utils.addClass(btnBack, 'active');
        myswipe.slideTo(attr, 10);
        ingBreadcrumb.innerHTML = ing.querySelector('.title').innerHTML;
        setTimeout(() => swiperContainer.classList.add('active'), 500);
        listIngredients.classList.remove('active');
        popinHeader.classList.remove('active');
      });
    });

    backToList.addEventListener('click', () => this.goBackToList(listIngredients, popinHeader, swiperContainer, btnClose, btnBack));
    btnBack.addEventListener('click', () => this.goBackToList(listIngredients, popinHeader, swiperContainer, btnClose, btnBack));
  }

  renderBlock(node) {
    const swiper = node.querySelector('.js-vc-slideshow');
    const swiperModal = node.querySelector('.js-vc-slidehsow-modal');
    const images = [...swiper.querySelectorAll('.js-modal')];
    const modal = node.querySelector('.modal-overlay');
    const closeBtn = modal.querySelector('.js-close');

    new Swiper(swiper, {
      loop: false,
      spaceBetween: 100,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    const mySwipeBlockModal = new Swiper(swiperModal, {
      loop: false,
      spaceBetween: 100,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    images.forEach((img) => {
      img.addEventListener('click', () => {
        Utils.addClass(modal, 'open');
        mySwipeBlockModal.update();
        mySwipeBlockModal.slideTo(img.getAttribute('data-slide-id'), 0);
      });
    });

    closeBtn.addEventListener('click', () => Utils.removeClass(modal, 'open'));
  }
}
